import { getHandle } from 'utils/router/utils/getHandle'

export const SystemKeywordsRoutes = [
  {
    path: 'system-keywords/:channel/:systemKeywordType/:mode?',
    handle: getHandle('keywords'),
    lazy: () => import('./systemKeywords.page'),
  },
] as const
